var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgImage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 5,
    stroke: "#717171",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.06407 16.8897C1.72701 17.1305 1.64894 17.5989 1.8897 17.9359C2.13046 18.273 2.59887 18.3511 2.93593 18.1103L2.06407 16.8897ZM21.5199 16.5762C21.8381 16.8413 22.311 16.7983 22.5762 16.4801C22.8413 16.1619 22.7983 15.689 22.4801 15.4238L21.5199 16.5762ZM7.07822 16.0782L6.54789 16.6085L7.07822 16.0782ZM2.93593 18.1103L5.19512 16.4966L4.32327 15.276L2.06407 16.8897L2.93593 18.1103ZM6.54789 16.6085L7.62114 17.6818L8.6818 16.6211L7.60855 15.5479L6.54789 16.6085ZM10.3789 17.6818L15.368 12.6927L14.3073 11.632L9.3182 16.6211L10.3789 17.6818ZM16.7827 12.6285L21.5199 16.5762L22.4801 15.4238L17.7429 11.4762L16.7827 12.6285ZM15.368 12.6927C15.752 12.3087 16.3655 12.2808 16.7827 12.6285L17.7429 11.4762C16.7297 10.6318 15.2399 10.6994 14.3073 11.632L15.368 12.6927ZM7.62114 17.6818C8.38266 18.4433 9.61734 18.4433 10.3789 17.6818L9.3182 16.6211C9.14246 16.7969 8.85754 16.7969 8.6818 16.6211L7.62114 17.6818ZM5.19512 16.4966C5.6128 16.1983 6.18494 16.2456 6.54789 16.6085L7.60855 15.5479C6.72711 14.6664 5.33762 14.5515 4.32327 15.276L5.19512 16.4966Z",
    fill: "#717171"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "matrix(-1 0 0 1 8 8)",
    stroke: "#717171",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgImage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/image.944c81ccd36324c2d84cbc1e3b241c4e.svg";